module.exports = __webpack_public_path__ + "img/1513931108.402b29ea.jpg";